import axios from "axios";

function minutesToMs (min) {
  if (min) {
    return min * 60 * 1000;
  } else {
    return 10000;
  }
}

export default {
  getMyReports(_, params) {
    return axios.post(`api/myreport/getmyreports`, params, { withCredentials: true });
  },
  createMyReports(_, params) {
    const type = params.report_type;
    if (type.includes("survey_report")){
      return axios.post(`api/myreport/createmyreport/survey`, params, { withCredentials: true, timeout: minutesToMs(15) });
    }
    if (type.includes("strategy_report")){
      return axios.post(`api/myreport/createmyreport/strategy`, params, { withCredentials: true, timeout: minutesToMs(15) });
    }
    if (type.includes("sustainability_report")){
      return axios.post(`api/myreport/createmyreport/sustainability`, params, { withCredentials: true, timeout: minutesToMs(15) });
    }
  },
  
  updateMyReports(_, params) {
    return axios.post(`api/myreport/updatemyreport`, params, { withCredentials: true });
  },

  deleteMyReports(_, params) {
    return axios.post(`api/myreport/deletemyreport`, params, { withCredentials: true });
  },
  
  checkReportPassPermissions() {
    return axios.get(`api/myreport/check-report-pass-permissions`, { withCredentials: true });
  },
  
  getSections() {
    return axios.get('api/report/getreportsections', { withCredentials: true });
  },
  generateReportSections(_, params) {
    return axios.post(`api/report/generatereportsections`, params, { withCredentials: true });
  },
  getSectionGenerations(_, params) {
    return axios.post(`api/sectiongeneration/getsectiongenerations`, params, { withCredentials: true });
  },
  createSectionGeneration(_, params) {
    return axios.post(`api/sectiongeneration/createsectiongeneration`, params, { withCredentials: true });
  },
  updateSectionGeneration(_, params) {
    return axios.post(`api/sectiongeneration/updatesectiongeneration/${params.id}`, 
    {
      section_generation_text: params.section_generation_text,
      updated_by: params.updated_by,
      section_seed_text: params.section_seed_text
    }, { withCredentials: true });

  },
  deleteSectionGeneration(_, params) {
    return axios.post(`api/sectiongeneration/deletesectiongeneration`, params, { withCredentials: true });
  },
  downloadMyReport(_, params) {
    return axios.post(`api/myreport/downloadmyreport`, params, { withCredentials: true });
  },
  getReportHeaders(_, params){
    return axios.post('/api/reportheader/getreportheaders', params,  {withCredentials: true });
  },

  createSustSection(_, params){
    return axios.post('/api/sectiongeneration/createsustreportsection', params,  {withCredentials: true, timeout: minutesToMs(15) });
  },
  getSustSection(_, params){
    return axios.post('/api/sectiongeneration/getsustreportsections', params,  {withCredentials: true });
  },
  updateSustSection(_, params){
    return axios.post(`/api/sectiongeneration/updatesustreportsection/${params.id}`, params.body, { withCredentials: true });
  },
  deleteSustSection(_, params){
    return axios.post('/api/sectiongeneration/deletesustreportsection', params, {withCredentials: true});
  },
  selectSustSection(_, params){
    return axios.post(`/api/sectiongeneration/selectsustreportsection/${params.id}`, params, {withCredentials: true});
  },


  createElementSection(_, params){
    return axios.post('/api/sectiongeneration/createelementsection', params,  {withCredentials: true, timeout: minutesToMs(15) });
  },
  getElementSection(_, params){
    return axios.post('/api/sectiongeneration/getelementsections', params,  {withCredentials: true });
  },
  updateElementSection(_, params){
    return axios.post(`/api/sectiongeneration/updateelementsection/${params.id}`, params.body, { withCredentials: true });
  },
  deleteElementSection(_, params){
    return axios.post('/api/sectiongeneration/deleteelementsection', params, {withCredentials: true});
  },
  selectElementSection(_, params){
    return axios.post(`/api/sectiongeneration/selectelementsection/${params.id}`, params, {withCredentials: true});
  },
  
  getCreatedSections(_, params){
    return axios.post(`/api/sectiongeneration/get-sections/${params.type}`, params.body, {withCredentials: true});
  },

  translateSection(_, params) {
    const body = params.body;
    if (params.type === 'element_section') {
      return axios.post(`/api/sectiongeneration/translateelementsection/${params.id}`, body, {withCredentials: true});
    } else if (params.type === 'report_section') {
      return axios.post(`/api/sectiongeneration/translatesustreportsection/${params.id}`, body, {withCredentials: true});
    } else {
      throw new Error('Invalid section type in translate section!');
    }
  },


  createdSectionHeaders(_, params){
    return axios.post ('/api/sectiongeneration/getcreatedsectionheaders', params, {withCredentials: true});
  },

  addOrganizationChart(_, params){
    return axios.post('/api/company/uploadcompanyorganizationchart', params, {withCredentials: true});
  },

  getGraphImagesInfo(_, params){
    return axios.post('/api/reportingprocesstrack/getgraphsinfo', params, {withCredentials: true});
  },

  getReportGraphData(_, params){
    return axios.get(`/api/reportingprocesstrack/report-graph-data/${params.su1}/${params.su2}`, {withCredentials: true});
  },

  resetReportGraphData(_, params){
    return axios.post(`/api/reportingprocesstrack/reset-graph-data`, params, {withCredentials: true});
  },
};
